import * as API from "../../api";
import * as ActionTypes from "../action-types";
import { batch } from "react-redux";

import { message } from "antd";

// Constants and Config

// Services
import * as Auth from "../../auth";

// Redux Action
import { setLoadingGeneral, unsetLoadingGeneral } from "./style";

// Neccessary Actions
import { auth_user_sign_out } from "../../../../main/services/redux/actions/user";

export const user_sign_in_request = (uid, cb) => (dispatch) => {
  dispatch(setLoadingGeneral());

  API.getInfoByUser(uid)
    .then((info) => {
      const { status, user } = info;

      if (status === 200) {
        if (user.status !== 0) {
          dispatch(user_sign_in_success(user));
          cb({ status: 200, user: user });
        } else {
          message.warning("Current employer being terminated");
        }
      } else {
        if (!user) {
          message.warning("No Verified User Found!");
        }
        // else if (user.status === 0) {
        //   message.error(
        //     "User has been suspended by Admin. Please contact iPick admin for further information"
        //   );
        // }
        dispatch(user_sign_out_request());
      }
      // }
    })
    .finally(() => {
      dispatch(unsetLoadingGeneral());
    });
};

const user_sign_in_success = (user) => {
  return {
    type: ActionTypes.USER_SIGN_IN,
    user,
  };
};

export const user_sign_out_request = () => (dispatch) => {
  batch(() => {
    dispatch(auth_user_sign_out());
    dispatch(user_sign_out_success());
  });
};

const user_sign_out_success = () => {
  return {
    type: ActionTypes.USER_SIGN_OUT,
  };
};

export const user_change_password_request =
  (email, oldPassword, newPassword, cb = () => {}) =>
  (dispatch) => {
    Auth.change_password(email, oldPassword, newPassword)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          cb({ status: 200 });
          batch(() => {
            dispatch(user_change_password_success());
            dispatch(user_sign_out_request());
          });
        } else {
          cb({ status: 404 });
        }
      })
      .catch((err) => {
        cb({});
      });
  };

const user_change_password_success = () => {
  return {
    type: ActionTypes.USER_UPDATE_PASSWORD,
  };
};

export const user_update_data_request =
  (items, cb = () => {}) =>
  (dispatch) => {
    API.updateUserInfo(items).then((info) => {
      const { status, user, msg } = info;
      if (status === 200) {
        dispatch(user_update_data_success(user));
        message.success(msg);
      } else {
        message.warning(msg);
      }
      cb();
    });
  };

const user_update_data_success = (user) => {
  return {
    type: ActionTypes.USER_UPDATE_DATA,
    user,
  };
};
